(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FormStorePointController', FormStorePointController);

    /** @ngInject */
    function FormStorePointController($rootScope, $scope, $uibModal, GoogleMapsService) {
        var vm = this;

        const ICON_INACTIVE = 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/pointactive.png';

        vm.store = $scope.store;
        vm.formInvalid = false;
        vm.mainMap = { center: { latitude: 0, longitude: 0 }, zoom: 2, control: {}, bounds: {}, markers: $scope.markers };

        getLocation();

        vm.options = {
            fullscreenControl: false
        };

        vm.mainMap.window = {
            model: {},
            show: false,
            options: {
                pixelOffset: { width: -1, height: -20 }
            },
            closeClick: function () {
                this.show = false;
            }
        };
        vm.mainMap.markerEvents = {
            click: function (marker, eventName, model, args) {
                vm.mainMap.window.model = model;
                vm.mainMap.window.show = true;
            }
        };

        vm.addSalesPoint = function () {
            $uibModal.open({
                templateUrl: 'app/admin/store-management/store-management-newsalespoint.html',
                controller: 'AddSalesPointManagementController',
                controllerAs: 'vm',
                scope: $scope,
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    pointlocation: function () {
                        return $scope.parameter;
                    },
                    pointparent: function () {
                        return $scope.$parent.vm;
                    }
                }
            });
        };

        $scope.$on('salesPointUpdated', function (event, data) {
            vm.mainMap.window.show = false;
            var markerUpdated;
            vm.mainMap.markers.forEach(function (marker) {
                if (marker.id === data.id) {
                    markerUpdated = marker;
                }
            });
            vm.mainMap.markers[vm.mainMap.markers.indexOf(markerUpdated)] = data;
        });

        $scope.$on('salesPointRemoved', function (event, data) {
            vm.mainMap.markers.splice(vm.mainMap.markers.indexOf(data), 1);
            vm.mainMap.window.show = false;
        });

        $scope.$on('salesPointCreated', function (event, data) {
            data.id = $scope.maker.actualMarker;
            data.options = { icon: ICON_INACTIVE };
            vm.mainMap.markers.push(data);
            $scope.maker.actualMarker++;
            vm.mainMap.window.show = false;
        });

        function getLocationSuccFn(position) {
            vm.mainMap.center.latitude = position.coords.latitude;
            vm.mainMap.center.longitude = position.coords.longitude;
            vm.mainMap.control.refresh({ latitude: vm.mainMap.center.latitude, longitude: vm.mainMap.center.longitude });
        }

        function getLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(getLocationSuccFn, function (error) {}, { timeout: 1000 });
            }
        }

        vm.refreshMapWithAddress = function () {
            var pl = (vm.salespoint && vm.salespoint.pointlocation) ? vm.salespoint.pointlocation : null;
            var src = vm.addressModel || pl;
            if (!src) return;
            var addr = [
                src.number || src.addressNumber,
                src.address,
                src.neighborhood || src.district,
                src.city,
                src.state,
                src.country
            ].filter(Boolean).join(', ').replace(/undefined/g, '').replace(/null/g, '');
            if (addr.trim() && vm.salespoint) {
                GoogleMapsService.getAddress(addr).then(function (data) {
                    if (data && data.geometry) {
                        vm.salespoint.latitude = data.geometry.location.lat();
                        vm.salespoint.longitude = data.geometry.location.lng();
                    }
                });
            }
        };

        function initSalesPoint() {
            vm.salespoint = {
                pointlocation: {
                    contactPhone: $scope.store.contactPhone,
                    name: $scope.store.name,
                    postalCode: '',
                    address: '',
                    number: '',
                    neighborhood: '',
                    city: '',
                    state: '',
                    country: ''
                }
            };
            vm.addressModel = {
                zipcode: '',
                address: '',
                addressNumber: '',
                district: '',
                complement: '',
                city: '',
                state: '',
                country: ''
            };
            $scope.$watch('vm.addressModel', function (newVal) {
                if (newVal && vm.salespoint && vm.salespoint.pointlocation) {
                    var pl = vm.salespoint.pointlocation;
                    pl.postalCode = newVal.zipcode;
                    pl.address = newVal.address;
                    pl.number = newVal.addressNumber;
                    pl.neighborhood = newVal.district;
                    pl.city = newVal.city;
                    pl.state = newVal.state;
                    pl.country = newVal.country;
                }
            }, true);
        }

        $rootScope.$on('form-invalid-sales-point', function () {
            vm.formInvalid = true;
        });

        $rootScope.$on('get-sales-point', function () {
            $rootScope.salespoint = vm.salespoint;
        });

        initSalesPoint();
    }
})();
